export const obtenerCookie = (nombreCookie: string): string | null => {
  const valor = `; ${document.cookie}`;
  const partes = valor.split(`; ${nombreCookie}=`);

  if (partes.length === 2) {
    return partes.pop()?.split(';').shift() ?? null;
  }

  return null;
};

export const guardarCookie = (nombreCookie: string, valor: string, dias = 1): void => {
  const fechaExpiracion = new Date(Date.now() + dias * 864e5).toUTCString();
  document.cookie = `${nombreCookie}=${valor}; expires=${fechaExpiracion}; path=/; samesite=strict`;
};

export const eliminarCookie = (nombreCookie: string): void => {
  document.cookie = `${nombreCookie}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; samesite=strict`;
};

export const obtenerTokenDesdeCookies = (): string | null => obtenerCookie('token');

export const limpiarCookiesAplicacion = (): void => {
  document.cookie.split(';').forEach((cookieActual) => {
    const indiceIgual = cookieActual.indexOf('=');
    const nombreCookie =
      indiceIgual > -1 ? cookieActual.substring(0, indiceIgual).trim() : cookieActual.trim();

    if (!nombreCookie.includes('cookie')) {
      eliminarCookie(nombreCookie);
    }
  });
};
